export default function ContactSection() {
  return (
    <section id="contact" className="py-20 md:py-28 bg-background-600">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="bg-background-700 rounded-[32px] p-10 md:p-16 flex flex-col lg:flex-row items-center gap-12">
          <div className="w-full lg:w-[55%]">
            <h2 className="text-5xl md:text-7xl font-heading font-black text-foreground-950 leading-none">
              有料要爆？
            </h2>
            <p className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-800">
              欢迎投稿
            </p>
            <p className="mt-6 text-sm text-foreground-600 leading-relaxed max-w-[400px]">
              如果你是知情人士，掌握网红、明星、主播等公众人物的真实黑料，欢迎通过下方入口向我们投稿。我们严格保护爆料人隐私，高质量爆料可获现金奖励。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <span className="inline-flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-accent-500"></i>
                tips@wuyichigua.com
              </span>
              <span className="hidden sm:block text-foreground-400/30">|</span>
              <span className="inline-flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-shield-check-line text-accent-500"></i>
                严格保护爆料人隐私
              </span>
            </div>
          </div>

          <div className="w-full lg:w-[45%] mt-8 lg:mt-0">
            <div className="space-y-5">
              <div className="border-b border-foreground-800/30 pb-3">
                <input
                  type="text"
                  placeholder="你的昵称（选填）"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder-foreground-500 outline-none py-1"
                />
              </div>
              <div className="border-b border-foreground-800/30 pb-3">
                <input
                  type="email"
                  placeholder="联系方式（选填）"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder-foreground-500 outline-none py-1"
                />
              </div>
              <div className="border-b border-foreground-800/30 pb-3">
                <textarea
                  placeholder="写下你的爆料内容..."
                  rows={3}
                  maxLength={500}
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder-foreground-500 outline-none py-1 resize-none"
                ></textarea>
              </div>
              <button className="px-8 py-3 rounded-full bg-foreground-950 text-background-50 font-bold text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer">
                发送爆料
                <i className="ri-arrow-right-line ml-1.5"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}